module.exports = __webpack_public_path__ + "static/media/zhongniuhushan_package.6aea3a8a.png";